export const ROUTES = {
    HOME: "/responsive-to-website",
    WORKS: "/works",
    RESUME: "/resume"
};  